import React from 'react';
import { Tooltip as TooltipContainer } from 'react-tooltip';

export const Tooltip = ({ anchor, text, style }) => {
  return (
    <TooltipContainer
      anchorSelect={anchor}
      place="top"
      opacity={1}
      style={{ backgroundColor: '#272A37', maxWidth: 'fit-content', padding: '4px 8px', borderRadius: '8px', zIndex: 1, ...style }}
    >
      <div className="d-flex align-items-center">
        <div className="font-size-12 font-base text-white">{text}</div>
      </div>
    </TooltipContainer>
  );
};
